import moment from 'moment';
import momentTimezone from 'moment-timezone';

export const returnCorrectDateFormat = (date: any) => {
    if (!date) return '';
    return moment(date).format('DD MMM yyyy');
};

export const returnCorrectDateAndTimeFormat = (date: any) => {
    if (!date) return '';

    const momentDate = moment(date);
    const today = moment().startOf('day');

    if (momentDate.isSame(today, 'day')) {
        return `Today at ${momentDate.format('HH:mm:ss')}`;
    } else {
        return momentDate.format('DD MMM yyyy, HH:mm:ss');
    }
};

export const returnCorrectDateFormatFromDashes = (date: string) => {
    if (!date) return '';
    return moment(date).format('DD MMM YYYY');
};

export const returnCorrectDateAndTimeFromUTC = (date: any) => {
    if (!date) return '';
    return moment(date).format('DD MMM yyyy, HH:mm');
};

export const getCurrentBrowserTimeZone = (): string => {
    return momentTimezone.tz.guess();
};
